import './styles/suscriptions.css'
import { useEffect, useState } from 'react'

//Components
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import Loader from '../components/loader'
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { useLocation, useNavigate } from 'react-router-dom'
import { addDoc, collection, deleteDoc, doc, getDocs, query, updateDoc } from 'firebase/firestore'
import { db } from '../assets/connections'
import { MdDeleteOutline } from "react-icons/md"
import { IoIosAddCircleOutline } from "react-icons/io"

const Suscriptions = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        subscriptions: [],
        newSubscriptions: [],
        deletedSubscriptions: []
    })

    //Varibles para el uso del confirm
    const [confirm, setConfirm] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que valida si hay campos vacios en las suscripciones
    const emptyFileds = (subscriptions) => {
        var cont = 0
        for (let i = 0; i < subscriptions.length; i++) {
            if (subscriptions[i].nombre_suscripcion === "") {
                cont++
            }
            if (subscriptions[i].fecha_pago === 0) {
                cont++
            }
        }

        if (cont > 0) {
            return true
        }
        return false
    }

    //Funcion que valida si las suscripciones estan repetidas
    const validateSubscriptions = () => {
        for (let i = 0; i < variables.subscriptions.length; i++) {
            var cont = 0
            for (let j = 0; j < variables.subscriptions.length; j++) {
                if (variables.subscriptions[i].nombre_suscripcion === variables.subscriptions[j].nombre_suscripcion) {
                    cont++
                }
            }

            for (let j = 0; j < variables.newSubscriptions.length; j++) {
                if (variables.subscriptions[i].nombre_suscripcion === variables.newSubscriptions[j].nombre_suscripcion) {
                    cont++
                }
            }

            if (cont > 1) {
                return 1
            }
        }

        return 0
    }

    //Funcion que guarda las nuevas suscripciones
    const onHandleGuardar = () => {
        //Primero validamos que no haya campos vacios en 
        if (emptyFileds(variables.subscriptions)) {
            showMessage("Debes completar todos los campos de las suscripciones", "warning")
        } else {
            if (emptyFileds(variables.newSubscriptions)) {
                showMessage("Debes completar todos los campos de las nuevas suscripciones", "warning")
            } else {

                //Validar si las suscripciones estan repetidas
                if (validateSubscriptions() === 0) {

                    setVariables(prev => ({
                        ...prev,
                        loading: true
                    }))

                    updateSubscriptions()

                } else {
                    showMessage("La suscripcion ya esta en la lista", "warning")
                }
            }
        }
    }
    const updateSubscriptions = async () => {
        var cont = 0

        //Primero actualizamos las que ya existian antes
        for (let i = 0; i < variables.subscriptions.length; i++) {
            await updateDoc(doc(doc(db, ref), "Suscripciones", variables.subscriptions[i].id), {
                fecha_pago: variables.subscriptions[i].fecha_pago,
                nombre_suscripcion: variables.subscriptions[i].nombre_suscripcion,
                dia_pago: variables.subscriptions[i].dia_pago
            }).catch(e => {
                cont++
            })
        }

        //Ahora agregamos las nuevas suscripciones
        if (variables.newSubscriptions.length > 0) {
            for (let i = 0; i < variables.newSubscriptions.length; i++) {
                await addDoc(collection(doc(db, ref), "Suscripciones"), variables.newSubscriptions[i]).catch(e => {
                    cont++
                })
            }
        }

        //Ahora eliminamos las suscripciones anteriores
        if (variables.deletedSubscriptions.length > 0) {
            for (let i = 0; i < variables.deletedSubscriptions.length; i++) {
                await deleteDoc(doc(doc(db, ref), "Suscripciones", variables.deletedSubscriptions[i].id)).catch(e => {
                    cont++
                })
            }
        }

        setVariables(prev => ({
            ...prev,
            loading: false
        }))

        if (cont <= 0) {
            setTimeout(() => {
                showMessage("Suscripciones actualizadas", "success")

                setTimeout(() => {
                    window.history.back()
                }, 2000)
            }, 100)
        } else {
            setTimeout(() => {
                showMessage("No se actualizaron las suscripciones. Vuleva a intentarlo", "error")

                setTimeout(() => {
                    window.history.back()
                }, 1000)

            }, 100)
        }
    }

    //Funcioon que obtiene las suscripciones de la academia
    const getData = async () => {
        await getDocs(query(collection(doc(db, ref), "Suscripciones"))).then(r => {

            var aux = []
            r.docs.map(v => {
                aux.push({
                    ...v.data(),
                    id: v.id
                })
            })

            setVariables(prev => ({
                ...prev,
                loading: false,
                subscriptions: aux
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener las suscripciones", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if (variables.loading) {
        return (
            <Loader
                loading={variables.loading}
            />
        )
    }

    if (!variables.loading)
        return (
            <div className='mainSuscriptions'>

                <Snack />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                />

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>SUSCRIPCIONES</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -40,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='contSuscriptions' style={{
                    fontFamily: fontType.text
                }}>
                    {
                        variables.subscriptions.map((v, i) => {
                            return (
                                <div className='suscription'>
                                    <div style={{
                                        flex: 2
                                    }}>
                                        {
                                            variables.subscriptions[i].nombre_suscripcion === "Inscripcion" ?
                                                <p style={{ fontSize: 16, fontWeight: "bold" }}>{v.nombre_suscripcion}</p>
                                                :
                                                variables.subscriptions[i].nombre_suscripcion === "Mensualidad" ?
                                                    <p style={{ fontSize: 16, fontWeight: "bold" }}>{v.nombre_suscripcion}</p>
                                                    :
                                                    <input
                                                        style={{
                                                            fontFamily: fontType.text
                                                        }}
                                                        textAlign='center'
                                                        placeholder='Suscripcion'
                                                        disabled={true}
                                                        value={variables.subscriptions[i].nombre_suscripcion.toString()}
                                                    />
                                        }

                                        <div className='custom-select'>
                                            <select value={variables.subscriptions[i].fecha_pago} placeholder="Modo de pago"
                                                style={{
                                                    fontFamily: fontType.text
                                                }}
                                                onChange={itemValue => {
                                                    var aux = variables.subscriptions
                                                    aux[i].fecha_pago = parseInt(itemValue.target.value)

                                                    setVariables(prev => ({
                                                        ...prev,
                                                        subscriptions: aux
                                                    }))
                                                }} mt={2} height={10} fontSize={16}>
                                                <option value={0}>Seleccionar tipo de suscripcion</option>
                                                <option value={-2}>Mensualidad</option>
                                                <option value={-1}>Anualidad</option>
                                                <option value={1}>Personalizar</option>
                                            </select>
                                        </div>

                                        {
                                            variables.subscriptions[i].fecha_pago === 1 ?
                                                <div>
                                                    <p>Todos los {variables.subscriptions[i].dia_pago} de cada mes</p>
                                                    <div className='custom-select'>
                                                        <select value={variables.subscriptions[i].dia_pago} placeholder="Modo de pago"
                                                            style={{
                                                                fontFamily: fontType.text
                                                            }}
                                                            onChange={itemValue => {
                                                                var aux = variables.subscriptions
                                                                aux[i].dia_pago = parseInt(itemValue.target.value)

                                                                setVariables(prev => ({
                                                                    ...prev,
                                                                    subscriptions: aux
                                                                }))
                                                            }} mt={2} height={10} fontSize={16}>
                                                            <option value={1}>1</option><option value={2}>2</option>
                                                            <option value={3}>3</option><option value={4}>4</option>
                                                            <option value={5}>5</option><option value={6}>6</option>
                                                            <option value={7}>7</option><option value={8}>8</option>
                                                            <option value={9}>9</option><option value={10}>10</option>
                                                            <option value={11}>11</option><option value={12}>12</option>
                                                            <option value={13}>13</option><option value={14}>14</option>
                                                            <option value={15}>15</option><option value={16}>16</option>
                                                            <option value={17}>17</option><option value={18}>18</option>
                                                            <option value={19}>19</option><option value={20}>20</option>
                                                            <option value={21}>21</option><option value={22}>22</option>
                                                            <option value={23}>23</option><option value={24}>24</option>
                                                            <option value={25}>25</option><option value={26}>26</option>
                                                            <option value={27}>27</option><option value={28}>28</option>
                                                            <option value={29}>29</option><option value={30}>30</option>
                                                            <option value={31}>31</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            :
                                            null
                                        }
                                        
                                    </div>

                                    {
                                        variables.subscriptions[i].nombre_suscripcion === "Inscripcion" ?
                                            null
                                            :
                                            variables.subscriptions[i].nombre_suscripcion === "Mensualidad" ?
                                                null
                                                :

                                                <MdDeleteOutline style={{
                                                    cursor: "pointer"
                                                }} size={30} color='red' onClick={() => {
                                                    //Quitar alguna de las suscripciones
                                                    variables.deletedSubscriptions.push(variables.subscriptions.splice(i, 1)[0])
                                                    setVariables(prev => ({
                                                        ...prev
                                                    }))
                                                }} />
                                    }
                                </div>
                            )
                        })
                    }

                    {
                        variables.newSubscriptions.length > 0 ?
                            <p style={{
                                fontFamily: fontType.title,
                                fontSize: 40,
                                marginTop: 30,
                                marginBottom: 10
                            }}>NUEVAS SUSCRIPCIONES</p>
                        :
                        null
                    }

                    {
                        variables.newSubscriptions.map((v, i) => {
                            return (
                                <div className='newSuscription'>
                                    <div style={{
                                        flex: 2
                                    }}>
                                        <input
                                            style={{
                                                fontFamily: fontType.text
                                            }}
                                            textAlign='center'
                                            placeholder='Suscripcion'
                                            value={variables.newSubscriptions[i].nombre_suscripcion.toString()}
                                            onChange={(e) => {
                                                variables.newSubscriptions[i].nombre_suscripcion = e.target.value.trim()
                                                setVariables(prev => ({
                                                    ...prev
                                                }))
                                            }}
                                        />
                                        
                                        <div className='custom-select'>
                                        <select value={variables.newSubscriptions[i].fecha_pago} placeholder="Modo de pago"
                                            style={{
                                                fontFamily: fontType.text
                                            }}
                                            onChange={itemValue => {
                                                var aux = variables.newSubscriptions
                                                aux[i].fecha_pago = parseInt(itemValue.target.value)

                                                setVariables(prev => ({
                                                    ...prev,
                                                    newSubscriptions: aux
                                                }))
                                            }} mt={2} height={10} fontSize={16}>
                                                <option value={0}>Seleccionar tipo de suscripcion</option>
                                                <option value={-2}>Mensualidad</option>
                                                <option value={-1}>Anualidad</option>
                                                <option value={1}>Personalizar</option>
                                        </select>
                                        </div>

                                        {
                                            variables.newSubscriptions[i].fecha_pago === 1 ?
                                                <div>
                                                    <p>Todos los {variables.newSubscriptions[i].dia_pago} de cada mes</p>
                                                    <div className='custom-select'>
                                                        <select value={variables.newSubscriptions[i].dia_pago} placeholder="Modo de pago"
                                                            style={{
                                                                fontFamily: fontType.text
                                                            }}
                                                            onChange={itemValue => {
                                                                var aux = variables.newSubscriptions
                                                                aux[i].dia_pago = parseInt(itemValue.target.value)

                                                                setVariables(prev => ({
                                                                    ...prev,
                                                                    newSubscriptions: aux
                                                                }))
                                                            }} mt={2} height={10} fontSize={16}>
                                                            <option value={1}>1</option><option value={2}>2</option>
                                                            <option value={3}>3</option><option value={4}>4</option>
                                                            <option value={5}>5</option><option value={6}>6</option>
                                                            <option value={7}>7</option><option value={8}>8</option>
                                                            <option value={9}>9</option><option value={10}>10</option>
                                                            <option value={11}>11</option><option value={12}>12</option>
                                                            <option value={13}>13</option><option value={14}>14</option>
                                                            <option value={15}>15</option><option value={16}>16</option>
                                                            <option value={17}>17</option><option value={18}>18</option>
                                                            <option value={19}>19</option><option value={20}>20</option>
                                                            <option value={21}>21</option><option value={22}>22</option>
                                                            <option value={23}>23</option><option value={24}>24</option>
                                                            <option value={25}>25</option><option value={26}>26</option>
                                                            <option value={27}>27</option><option value={28}>28</option>
                                                            <option value={29}>29</option><option value={30}>30</option>
                                                            <option value={31}>31</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            :
                                            null
                                        }
                                    </div>

                                    <MdDeleteOutline style={{
                                        cursor: "pointer"
                                    }} size={30} color='red' onClick={() => {
                                            //Quitar una nueva suscripcion
                                            variables.newSubscriptions.splice(i, 1)
                                            setVariables(prev => ({
                                                ...prev
                                            }))
                                        }} 
                                    />

                                </div>
                            )
                        })
                    }

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        marginBottom: 30
                    }}>
                        <IoIosAddCircleOutline style={{
                            cursor: "pointer"
                        }} size={50} color={main} onClick={() => {
                                //Agregamos una nueva suscrpcion al catalogo
                                var aux = variables.newSubscriptions
                                aux.push({
                                    fecha_pago: 0,
                                    nombre_suscripcion: "",
                                    dia_pago: 1
                                })

                                setVariables(prev => ({
                                    ...prev,
                                    newSubscriptions: aux
                                }))
                            }} 
                        />
                    </div>

                    <button className='buttonSave' style={{
                        fontFamily: fontType.title,
                        color: "white",
                        backgroundColor: main,
                        fontSize: 20
                    }} onClick={onHandleGuardar}>
                        GUARDAR
                    </button>

                </div>

            </div>
        )
}

export default Suscriptions